import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
const icons = { SummarizeOutlinedIcon };

// ==============================|| MENU ITEMS - REPORT AND NOTIFICATION ||============================== //

const reportAndNotification = {
  id: 'report-and-notification',
  type: 'group',
  children: [
    {
      id: 'report-and-notification',
      title: 'Report',
      type: 'item',
      url: '/report',
      icon: icons.SummarizeOutlinedIcon
    }
  ]
};

export default reportAndNotification;
